import { useState } from 'react';

const faqs = [
  {
    q: '红桃tv是否需要注册才能观看？',
    a: '部分内容支持免注册观看，但注册成为红桃tv会员后，可以享受更多高清内容、无广告播放、专属推荐等增值服务。注册过程简单快捷，支持手机号一键注册。',
  },
  {
    q: '红桃tv支持哪些设备观看？',
    a: '红桃tv全面支持手机（iOS/Android）、平板、电脑网页端、智能电视（TV版）等多种设备。一个账号，多端同步，随时随地畅享高清视频。',
  },
  {
    q: '红桃tv的视频画质如何？卡不卡？',
    a: '红桃tv采用先进的流媒体传输技术，支持1080P、4K超高清画质播放。智能码率自适应算法会根据您的网络状况自动调整，确保流畅不卡顿的观看体验。',
  },
  {
    q: '红桃tv的内容更新频率如何？',
    a: '我们与国内外多家内容方深度合作，电视剧、综艺等热门内容基本做到同步更新。电影和纪录片也在持续扩充中，每天都有新内容上线。',
  },
  {
    q: '如何下载红桃tv APP？',
    a: '您可以在苹果App Store或各大安卓应用市场搜索"红桃tv"下载官方APP。也可以在官网首页点击"下载APP"按钮，扫描二维码直接下载。',
  },
  {
    q: '红桃tv的最新地址是什么？',
    a: '红桃tv官方唯一域名是 hongtaotv.com（示例），请认准官方网站。建议收藏本站或关注官方公众号获取最新动态，避免访问到仿冒网站。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="bg-background-100/70 py-10 md:py-14">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            解答你对红桃tv的疑问
          </p>
        </div>

        <div className="max-w-3xl mx-auto flex flex-col gap-3">
          {faqs.map((faq, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div
                key={idx}
                className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
              >
                <button
                  className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer hover:bg-background-50/80 transition-colors"
                  onClick={() => setOpenIndex(isOpen ? null : idx)}
                  aria-expanded={isOpen}
                >
                  <h3 className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                    {faq.q}
                  </h3>
                  <i
                    className={`ri-arrow-down-s-line text-foreground-400 transition-transform duration-300 text-lg flex-shrink-0 ${
                      isOpen ? 'rotate-180' : ''
                    }`}
                  ></i>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    isOpen ? 'max-h-96' : 'max-h-0'
                  }`}
                >
                  <p className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}